import { format, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

const TIMEZONE = 'Asia/Kolkata';

/**
 * Format a date string to IST (e.g., "12 Dec 2025, 2:30 PM")
 * @param {string|Date} date - The date to format
 * @param {string} formatStr - Optional format string (default: 'dd MMM yyyy, h:mm a')
 * @returns {string} - Formatted date string
 */
export const formatToIST = (date, formatStr = 'dd MMM yyyy, h:mm a') => {
  if (!date) return '-';
  try {
    const d = typeof date === 'string' ? parseISO(date) : date;
    const zonedDate = toZonedTime(d, TIMEZONE);
    return format(zonedDate, formatStr);
  } catch (error) {
    console.error('Date formatting error:', error);
    return '-';
  }
};

/**
 * Format a date string to IST Date only (e.g., "12 Dec 2025")
 * @param {string|Date} date 
 * @returns {string}
 */
export const formatDateIST = (date) => {
  return formatToIST(date, 'dd MMM yyyy');
};

/**
 * Format a date string to IST Time only (e.g., "2:30 PM")
 * @param {string|Date} date 
 * @returns {string}
 */
export const formatTimeIST = (date) => {
  return formatToIST(date, 'h:mm a');
};
